export default __webpack_public_path__ + "static/media/messageError.3adaec5a.svg";